import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex items-center gap-x-1" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("b", null, "Winner", -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" pts | ")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("b", null, "Extras", -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" pts | ")
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("b", null, "+/- Exact Bonus"),
  /*#__PURE__*/_createTextVNode(" 2 pts")
], -1)
const _hoisted_8 = { class: "flex justify-end flex-1 gap-x-1" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Social ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("-")
const _hoisted_11 = { class: "flex flex-col justify-between w-full py-3 px-7" }
const _hoisted_12 = {
  key: 0,
  class: "grid grid-cols-2 gap-x-2"
}
const _hoisted_13 = { class: "flex justify-between w-full py-3 px-7" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Add Blank")
const _hoisted_15 = { class: "flex w-1/2 gap-x-1" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode("Add From Template")

import { TEAM_NONE_ID, WRESTLER_NONE_ID } from '@/symbols/constants';
import { Match, MatchParticipant, MatchWinnerType } from '@/typings/scorecard';
import { computed, onMounted, ref } from 'vue';
import ExtraEditor from '@/components/Scorecard/ExtraEditor.vue';
import ParticipantsEditor from '@/components/Scorecard/Participants/ParticipantsEditor.vue';
import ScorecardSectionEditor from '@/components/Scorecard/ScorecardSectionEditor.vue';
import PotentialScore from '@/components/Scorecard/PotentialScore.vue';
import { useVModels } from '@vueuse/core';
import Checkbox from '@/components/Inputs/Checkbox.vue';
import { Template, TemplateType } from '@/typings/template';
import { useTemplateStore } from '@/store/template';
import { cloneDeep } from 'lodash';
import { SearchItem } from '@/typings/dropdown';
import Modal from '@/components/Modal/Modal.vue';
import TextField from '@/components/Inputs/TextField.vue';
import draggable from 'vuedraggable';
import SearchDropdown from '@/components/Inputs/SearchDropdown.vue';

interface Props {
  match: Match;
}

interface Emits {
  (e: 'participantsChanged'): void;
  (e: 'remove'): void;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    match: null
  },
  emits: ["participantsChanged", "remove"],
  setup(__props: any, { expose, emit }: { emit: ({
  (e: 'participantsChanged'): void;
  (e: 'remove'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  match: Match;
}

const matchScore = computed(
  () =>
    matchModel.value.Questions.length * matchModel.value.ExtraPointValue +
    (matchModel.value.HasWinner ? matchModel.value.WinnerPointValue : 0) +
    matchModel.value.Questions.filter((e) => e.Type === 'Number').length * 2
);



const { match: matchModel } = useVModels(props);

const selectedTemplate = ref<Template>();

const section = ref<InstanceType<typeof ScorecardSectionEditor> | null>(null);
const sectionUuid = computed(() =>
  !section.value ? '' : section.value.sectionUuid
);

const templateStore = useTemplateStore();

const templateValues = computed(() =>
  templateStore.templates.map((t) => ({
    text: t.Text,
    value: t,
  }))
);

function addExtra(template?: Template) {
  if (template) {
    matchModel.value.Questions.push({
      Text: template.Text.toString(),
      Type: template.Type.toString(),
      Options: cloneDeep(template.Options),
      SocialFormat: template.SocialFormat.toString(),
      UserNotes: template.UserNotes.toString(),
      BaseValue: 0,
      Order: 0,
    });
  } else {
    matchModel.value.Questions.push({
      Text: '',
      Type: TemplateType.Number,
      Options: [],
      SocialFormat: ': {0}',
      UserNotes: '',
      BaseValue: 0,
      Order: 0,
    });
  }
}

const winnerTypes = ref<SearchItem[]>([
  {
    value: MatchWinnerType.Participating,
    text: 'Participating wrestlers/teams only',
  },
  {
    value: MatchWinnerType.AllWrestlers,
    text: 'All available wrestlers or custom',
  },
]);

const socialFormats = ref<SearchItem[]>([
  {
    value: '{{WINNER}} wins by {{FALL}}',
    text: '{{WINNER}} wins by {{FALL}} (e.g. Pac wins by Pin)',
  },
  {
    value: '{{MAKER}} {{FALLS}} {{TAKER}}',
    text: '{{MAKER}} {{FALLS}} {{TAKER}} (e.g. Sting pins The Rock)',
  },
]);

onMounted(() => {
  if (templateStore.templates.length === 0) templateStore.getTemplates();
});

const socialEditorVisible = ref(false);

function handleTypePicked(firstTime: boolean) {
  if (firstTime) {
    matchModel.value.HasWinner = true;
    if (
      matchModel.value.Participants[0] &&
      matchModel.value.Participants[0].SuperstarId !== undefined
    ) {
      matchModel.value.Participants.unshift({
        SuperstarId: WRESTLER_NONE_ID,
        ExtraText: '',
      });
    } else {
      matchModel.value.SocialWinnerFormat = '{{MAKER}} {{FALLS}} {{TAKER}}';
      matchModel.value.Teams.unshift({
        TeamId: TEAM_NONE_ID,
        ExtraText: '',
      });
    }
  }
}
const drag = ref(false);



function removeExtra(index: number) {
  if (matchModel.value.Questions[index].QuestionId) {
    matchModel.value.Questions[index].Deleted =
      !matchModel.value.Questions[index].Deleted;
  } else {
    matchModel.value.Questions.splice(index, 1);
  }
}

const participants = computed({
  get() {
    return [...matchModel.value.Participants, ...matchModel.value.Teams];
  },
  set(newValue: MatchParticipant[]) {
    matchModel.value.Participants = newValue.filter((x) => !!x.SuperstarId);
    matchModel.value.Teams = newValue.filter((x) => !!x.TeamId);
  },
});

const isValid = computed(() => {
  const validName = matchModel.value.Title.length > 0;

  const validExtras =
    matchModel.value.HasWinner || matchModel.value.Questions.length > 0;

  let validParticipants = true;
  for (const participant of matchModel.value.Participants) {
    if (participant.SuperstarId === null) {
      validParticipants = false;
    }
  }
  for (const participant of matchModel.value.Teams) {
    if (participant.TeamId === null) {
      validParticipants = false;
    }
  }

  return validName && validExtras && validParticipants;
});
expose({ sectionUuid, isValid });

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(ScorecardSectionEditor, {
      title: _unref(matchModel).Title,
      "onUpdate:title": _cache[14] || (_cache[14] = ($event: any) => ((_unref(matchModel).Title) = $event)),
      subtitle: _unref(matchModel).Subtitle,
      "onUpdate:subtitle": _cache[15] || (_cache[15] = ($event: any) => ((_unref(matchModel).Subtitle) = $event)),
      thirdTitle: _unref(matchModel).ThirdTitle,
      "onUpdate:thirdTitle": _cache[16] || (_cache[16] = ($event: any) => ((_unref(matchModel).ThirdTitle) = $event)),
      ref: (_value, _refs) => {
        _refs['section'] = _value
        section.value = _value
      },
      class: _normalizeClass(["border-l-4", {
      'border-green-500': _unref(isValid),
      'border-red-500': !_unref(isValid),
      'line-through': _unref(matchModel).Deleted,
    }])
    }, {
      info: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          (_unref(matchModel).HasWinner)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _hoisted_3,
                _withDirectives(_createElementVNode("input", {
                  class: "ml-1",
                  type: "number",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(matchModel).WinnerPointValue) = $event))
                }, null, 512), [
                  [_vModelText, _unref(matchModel).WinnerPointValue]
                ]),
                _hoisted_4
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            _hoisted_5,
            _withDirectives(_createElementVNode("input", {
              class: "ml-1",
              type: "number",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(matchModel).ExtraPointValue) = $event))
            }, null, 512), [
              [_vModelText, _unref(matchModel).ExtraPointValue]
            ]),
            _hoisted_6
          ]),
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_Button, {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (socialEditorVisible.value = true)),
              type: !_unref(matchModel).SocialMatchName ? 'other' : 'primary',
              class: _normalizeClass({
              'bg-gray-400 hover:bg-gray-500': !_unref(matchModel).SocialMatchName,
            })
            }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            }, 8, ["type", "class"]),
            _createVNode(_component_Button, {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (emit('remove')))
            }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            })
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(ParticipantsEditor, {
            participants: _unref(participants),
            match: _unref(matchModel),
            onTypePicked: handleTypePicked,
            onAdd: _cache[4] || (_cache[4] = ($event: any) => (emit('participantsChanged')))
          }, null, 8, ["participants", "match"]),
          _createVNode(Checkbox, {
            modelValue: _unref(matchModel).HasWinner,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(matchModel).HasWinner) = $event)),
            title: "Match has winner?"
          }, null, 8, ["modelValue"]),
          (_unref(matchModel).HasWinner)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createVNode(SearchDropdown, {
                  title: "Winner",
                  modelValue: _unref(matchModel).WinnerType,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(matchModel).WinnerType) = $event)),
                  items: winnerTypes.value
                }, null, 8, ["modelValue", "items"]),
                _createVNode(SearchDropdown, {
                  title: "Social Format",
                  modelValue: _unref(matchModel).SocialWinnerFormat,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(matchModel).SocialWinnerFormat) = $event)),
                  items: socialFormats.value
                }, null, 8, ["modelValue", "items"])
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_unref(draggable), {
          modelValue: _unref(matchModel).Questions,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(matchModel).Questions) = $event)),
          group: "matches",
          handle: ".handle",
          tag: "div",
          "item-key": "QuestionId",
          onStart: _cache[9] || (_cache[9] = ($event: any) => (drag.value = true)),
          onEnd: _cache[10] || (_cache[10] = ($event: any) => (drag.value = false))
        }, {
          item: _withCtx(({ element, index }) => [
            _createElementVNode("div", null, [
              _createVNode(ExtraEditor, {
                extra: element,
                onRemove: ($event: any) => (removeExtra(index))
              }, null, 8, ["extra", "onRemove"])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_Button, {
            onClick: _cache[11] || (_cache[11] = ($event: any) => (addExtra()))
          }, {
            default: _withCtx(() => [
              _hoisted_14
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(SearchDropdown, {
              title: "Template",
              modelValue: selectedTemplate.value,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((selectedTemplate).value = $event)),
              items: _unref(templateValues)
            }, null, 8, ["modelValue", "items"]),
            _createVNode(_component_Button, {
              onClick: _cache[13] || (_cache[13] = ($event: any) => (addExtra(selectedTemplate.value)))
            }, {
              default: _withCtx(() => [
                _hoisted_16
              ]),
              _: 1
            })
          ])
        ]),
        _createVNode(PotentialScore, { score: _unref(matchScore) }, null, 8, ["score"])
      ]),
      _: 1
    }, 8, ["title", "subtitle", "thirdTitle", "class"]),
    (socialEditorVisible.value)
      ? (_openBlock(), _createBlock(Modal, {
          key: 0,
          header: "Edit Socials",
          onClose: _cache[18] || (_cache[18] = ($event: any) => (socialEditorVisible.value = false))
        }, {
          default: _withCtx(() => [
            _createVNode(TextField, {
              title: "Match Hashtags/Name",
              modelValue: _unref(matchModel).SocialMatchName,
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_unref(matchModel).SocialMatchName) = $event)),
              hint: "This is how the match will appear on social posts."
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})